/**
 * Profile & Settings screen navigation constants.
 *
 * TODO: Confirm whether these types/constants should live in Platform
 * or be moved to PlatformComponents for reuse across packages.
 * Tracking: https://app.asana.com/0/1217188638989179
 */

export const PROFILE_TOOL_NAME = 'jsma-web-profile-toolName'

export const PROFILE_SCREENS = {
    PROFILE: 'profile',
    NOTIFICATION_SETTINGS: 'notification-settings',
    PUSH: 'push',
} as const

export type ProfileScreen = typeof PROFILE_SCREENS[keyof typeof PROFILE_SCREENS]

export type NotificationSubPage = 'push'

export interface IUserProfile {
    name: string
    email: string
    /**
     * i18n key for the user's role label (e.g. 'jsma-web-profile-roleAdmin').
     * Undefined while still loading; resolved via resolveDisplayRole(). See
     * LLD P519075237 for why this is a resolved i18n key, not a raw Role enum
     * value or a hardcoded string.
     */
    role?: string
}
